import type { ProductSort, ProductStatus } from '@/shared/api/types/generated';

export type SellHistoryTabValue = 'sold' | 'removed' | 'unsold' | 'onSale';

// Filtres locaux de vue du feed : marques + tri uniquement. L'état, le prix et
// les autres attributs d'articles sont pilotés par la barre de segment.
export interface ProductFilters {
  brands?: string[];
  sort?: ProductSort;
}

export interface SellHistoryFilters extends ProductFilters {
  searchText?: string;
}

export interface SellHistoryState {
  activeTab: SellHistoryTabValue;
  filters: SellHistoryFilters;
}

export const SELL_HISTORY_TAB_STATUS_MAPPING: Record<SellHistoryTabValue, ProductStatus> = {
  sold: 'sold',
  removed: 'removed',
  unsold: 'expired',
  onSale: 'active',
};

// `label` est une CLÉ i18n — traduite via t() au render (SellHistoryTabs)
export const SELL_HISTORY_TABS = [
  { value: 'sold' as const, label: 'salesFeed.tabSold' },
  { value: 'removed' as const, label: 'salesFeed.tabRemoved' },
  { value: 'unsold' as const, label: 'salesFeed.tabUnsold' },
] as const;

// Analyse VENDEUR : uniquement Ventes + En vente (le stock actuel du profil)
export const VENDOR_SELL_HISTORY_TABS = [
  { value: 'sold' as const, label: 'salesFeed.tabSold' },
  { value: 'onSale' as const, label: 'salesFeed.tabOnSale' },
] as const;
